import { Box, Table, TableHead, TableRow, TableCell, TableContainer, TableBody } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import { useNavigate } from "react-router";

export default function ListRolesComponent({ roles, loadingGetRoles }) {

    const navigate = useNavigate();

    const hasPermission = (permissions, sectionName, action) => {
        const permission = permissions.find(p => p.section.name === sectionName);
        return permission ? permission.actions.includes(action) : false;
    };

    const ActionIcon = ({ exists }) => {
        return exists ? 
            <CheckCircleIcon sx={{ color: green[500] }} /> : 
            <CancelIcon sx={{ color: red[500] }} />;
    };

    const handleEdit = (role) => {
        navigate(`/rrhh/roles/crear/${role.hash_code}`);
    };

    const handleDelete = (role) => {
        console.log(role);
    };
    
    return (
        <Box>   
            <TableContainer sx={{ height: "750px", overflow: "auto" }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Rol</TableCell>
                            <TableCell>Descripción</TableCell>
                            <TableCell>Sección</TableCell>
                            <TableCell>Nombre Permiso</TableCell>
                            <TableCell align="center">Crear</TableCell>
                            <TableCell align="center">Editar</TableCell>
                            <TableCell align="center">Eliminar</TableCell>
                            <TableCell align="center">Ver</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {roles.map((role) => {
                            // Si el rol no tiene permisos, mostrar una fila con solo el nombre y descripción
                            if (!role.permissions || role.permissions.length === 0) {
                                return (
                                    <TableRow sx={{ cursor: "pointer" }} key={role.id} onClick={() => handleEdit(role)}>
                                        <TableCell>{role.name}</TableCell>
                                        <TableCell>{role.description}</TableCell>
                                        <TableCell colSpan={6}>Sin permisos asignados</TableCell>
                                    </TableRow>
                                );
                            }

                            // Si tiene permisos, mostrar una fila por cada permiso
                            return role.permissions.map((permission, permIndex) => (
                                <TableRow sx={{ cursor: "pointer" }} key={`${role.id}-${permission.id}`} onClick={() => handleEdit(role)}>
                                    {permIndex === 0 && (
                                        <>
                                            <TableCell rowSpan={role.permissions.length}>{role.name}</TableCell>
                                            <TableCell rowSpan={role.permissions.length}>{role.description}</TableCell>
                                        </>
                                    )}
                                    <TableCell>{permission.section.name}</TableCell>
                                    <TableCell>{permission.name}</TableCell>
                                    <TableCell align="center">
                                        <ActionIcon exists={permission.actions.includes('create')} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <ActionIcon exists={permission.actions.includes('update')} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <ActionIcon exists={permission.actions.includes('delete')} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <ActionIcon exists={permission.actions.includes('read')} />
                                    </TableCell>
                                </TableRow>
                            ));
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}